import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import moment from "moment"
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';

import '../../../styles/reports/reports-common.scss';
import { enterFunctionV2, focusElement, handlekeyDown } from '../../../components/generics/helper';
import BranchAutocomplete from '../../../components/formik-form-components/BranchAutocomplete';
import BrandAutocomplete from '../../../components/formik-form-components/BrandAutocomplete';
import CategoryAutocomplete from '../../../components/formik-form-components/CategoryAutocomplete';
import DatepickerV2 from '../../../components/shared/DatepickerV2';
import ItemAutocomplete from '../../../components/formik-form-components/ItemAutocomplete';
import PurchaseInvoiceReportList from './PurchaseInvoiceReportList';
import VendorAutocomplete from "../../../components/formik-form-components/VendorAutocomplete";

const PurchaseInvoiceReport = () => {
    const userData = useSelector((state) => state.login.userData);
    const filterInitialValue = { fromDate: moment(new Date()).format("YYYY-MM-DD"), toDate: moment(new Date()).format("YYYY-MM-DD"), searchBillBranchIds: userData?.branchId ?? '', searchBillBranchNames: [], searchShipBranchIds: '', searchShipBranchNames: [], searchCategoryIds: '', searchCategoryNames: [], searchSuperCategory: '', searchSubCategoryIds: '', searchSubCategoryNames: [], searchBrandIds: '', searchBrandNames: [], searchItemIds: '', searchItemNames: [], searchVendorIds: '', searchVendorNames: [], showTable: false, dateType: "I" };
    const [filters, setFilters] = useState(filterInitialValue)
    const [resetDate, setResetDate] = useState(false);
    const [loadData, setLoadData] = useState(false);

    const billBranchFilterRef = useRef(null);
    const shipBranchFilterRef = useRef(null);
    const itemFilterRef = useRef(null);
    const categoryFilterRef = useRef(null);
    const subCategoryFilterRef = useRef(null);
    const brandFilterRef = useRef(null);
    const vendorFilterRef = useRef(null);

    const purchaseInvoiceReportFilterReset = () => {
        setFilters({ ...filterInitialValue });
        billBranchFilterRef.current.resetAutocomplete();
        shipBranchFilterRef.current.resetAutocomplete();
        itemFilterRef.current.resetAutocomplete();
        categoryFilterRef.current.resetAutocomplete();
        subCategoryFilterRef.current.resetAutocomplete();
        brandFilterRef.current.resetAutocomplete();
        vendorFilterRef.current.resetAutocomplete();
        setResetDate(true);
    }

    const generatePurchaseInvoiceData = () => {
        setFilters((prev) => ({ ...prev, showTable: true }))
        setLoadData(true);
    }
    useEffect(() => {
        focusElement('purchaseInvoiceFromDate')
    }, [])

    return (
        <>
            <div key="pir_wrapper" className="report--wrapper">
                <div key="pir_filter_wrapper" className="report--filter--wrapper pi--report--filter">
                    <div className="fuel--voucher--radio--wrap">
                        <FormControl >
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={filters.dateType}
                                onChange={(e) => setFilters({ ...filters, dateType: e.target.value })}
                                className="retrieve--by--filter--options--container"
                            >
                                <FormControlLabel
                                    value="I"
                                    id="invoiceDate"
                                    style={{ fontWeight: '600 !important' }}
                                    control={<Radio />}
                                    label="Invoice Date"
                                    onKeyDown={(e) => enterFunctionV2(e, 'receivingDate', '')}
                                />
                                <FormControlLabel
                                    value="R"
                                    id="receivingDate"
                                    control={<Radio />}
                                    label="Receiving Date"
                                    onKeyDown={(e) => enterFunctionV2(e, 'purchaseInvoiceFromDate', 'invoiceDate')}
                                />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    <div key="pir_filter_inp_container" className="input--container">
                        <DatepickerV2
                            name={'filter_from_dt'}
                            type="filter_from_dt"
                            className=""
                            star={true}
                            emptyField={''}
                            Reset={resetDate}
                            id="purchaseInvoiceFromDate"
                            label={filters.dateType === 'I' ? "From Invoice Date" : "From Receiving Date"}
                            dateChange={(newValue) => {
                                setResetDate(false);
                                setFilters(previousFilters => ({ ...previousFilters, fromDate: moment(newValue).format("YYYY-MM-DD"), showTable: false }));
                                focusElement("purchaseInvoiceToDate")
                            }}
                        />
                    </div>
                    <div key="pir_filter_inp_tod" className="input--container" >
                        <DatepickerV2
                            name={'filter_to_dt'}
                            type="filter_to_dt"
                            className=""
                            label={filters.dateType === 'I' ? "To Invoice Date" : "To Receiving Date"}
                            fromDate={filters?.fromDate}
                            star={true}
                            enableFuture={true}
                            emptyField={''}
                            Reset={resetDate}
                            id="purchaseInvoiceToDate"
                            dateChange={(newValue) => {
                                setResetDate(false);
                                setFilters(previousFilters => ({ ...previousFilters, toDate: moment(newValue).format("YYYY-MM-DD"), showTable: false }));
                                focusElement("searchVendorIds")
                            }}
                        />
                    </div>
                    <div className="input--container" >
                        <VendorAutocomplete
                            id="searchVendorIds"
                            name="searchVendorIds"
                            label="Vendor Name"
                            searchPlaceholder="Search By Vendor Name"
                            noDataLabel="No Vendor Name Found"
                            isCompulsory={false}
                            singleSelect={false}
                            allOption={false}
                            listWidth={window.innerWidth === 1024 ? 280 : 450}
                            selectedValues={filters.searchVendorIds ? filters.searchVendorIds.split(',') : []}
                            onSelect={(selectedVendors) => {
                                const searchVendorIds = selectedVendors.map((v) => v.vendorId).sort().join(',');
                                const searchVendorNames = selectedVendors.map((v) => v.vendorName).sort();
                                setFilters(prev => ({ ...prev, searchVendorIds, searchVendorNames, showTable: false }));
                            }}
                            onRemove={(selectedVendors) => {
                                const searchVendorIds = selectedVendors.map((v) => v.vendorId).sort().join(',');
                                const searchVendorNames = selectedVendors.map((v) => v.vendorName).sort();
                                setFilters(prev => ({ ...prev, searchVendorIds, searchVendorNames, showTable: false }));
                            }}
                            ref={vendorFilterRef}
                            nextId="searchBillBranchIds"
                            prevId=""
                        />
                    </div>
                    <div key="pir_filter_inp_branch" className="input--container">
                        <BranchAutocomplete
                            id={'searchBillBranchIds'}
                            name={'searchBillBranchIds'}
                            label={"Billing Branch"}
                            searchPlaceholder={"Search By Bill Branch Name"}
                            noDataLabel={"No Bill Branch Found"}
                            isCompulsory={false}
                            singleSelect={false}
                            allOption={false}
                            selectedValues={filters.searchBillBranchIds !== '' ? filters.searchBillBranchIds.split(',') : []}
                            listWidth={300}
                            onSelect={(selectedBranches, currentSelection) => {
                                const searchBillBranchIds = selectedBranches.map((b) => b.branchId).sort().join(',');
                                const searchBillBranchNames = selectedBranches.map((b) => b.branchName).sort();
                                setFilters(previousFilters => ({ ...previousFilters, searchBillBranchIds, searchBillBranchNames, showTable: false }));
                            }}
                            onRemove={(selectedBranches, currentSelection) => {
                                const searchBillBranchIds = selectedBranches.map((b) => b.branchId).sort().join(',');
                                const searchBillBranchNames = selectedBranches.map((b) => b.branchName).sort();
                                setFilters(previousFilters => ({ ...previousFilters, searchBillBranchIds, searchBillBranchNames, showTable: false }));
                            }}
                            ref={billBranchFilterRef}
                            nextId='searchShipBranchIds'
                            prevId='searchVendorIds'
                        />
                    </div>
                    <div key="pir_filter_inp_shipbranch" className="input--container">
                        <BranchAutocomplete
                            id={'searchShipBranchIds'}
                            name={'searchShipBranchIds'}
                            label={"Shipping Branch"}
                            searchPlaceholder={"Search By Ship Branch Name"}
                            noDataLabel={"No Ship Branch Found"}
                            isCompulsory={false}
                            singleSelect={false}
                            allOption={false}
                            selectedValues={['']}
                            listWidth={300}
                            onSelect={(selectedBranches, currentSelection) => {
                                const searchShipBranchIds = selectedBranches.map((b) => b.branchId).sort().join(',');
                                const searchShipBranchNames = selectedBranches.map((b) => b.branchName).sort();
                                setFilters(previousFilters => ({ ...previousFilters, searchShipBranchIds, searchShipBranchNames, showTable: false }));
                            }}
                            onRemove={(selectedBranches, currentSelection) => {
                                const searchShipBranchIds = selectedBranches.map((b) => b.branchId).sort().join(',');
                                const searchShipBranchNames = selectedBranches.map((b) => b.branchName).sort();
                                setFilters(previousFilters => ({ ...previousFilters, searchShipBranchIds, searchShipBranchNames, showTable: false }));
                            }}
                            ref={shipBranchFilterRef}
                            nextId='categoryIds'
                            prevId='searchBillBranchIds'
                        />
                    </div>
                    <div key="pir_filter_inp_category" className="input--container" style={{ width: '21%' }}>
                        <CategoryAutocomplete
                            name="categoryIds" nextId="subCategoryIds" prevId="searchShipBranchIds"
                            id={'categoryIds'}
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={250}
                            label={"Item Category"}
                            searchPlaceholder={"Search By Category"}
                            noDataLabel={"No Category Found"}
                            categoryFor={1}
                            isParent="Y"
                            selectedValues={filters.searchCategoryIds !== '' ? [filters.searchCategoryIds] : ['']}
                            onSelect={(selectedCategories) => {
                                const searchCategoryIds = selectedCategories.map((v) => v.categoryId).sort().join(',');
                                const searchSuperCategory = selectedCategories.length > 0 ? selectedCategories[0].superCategory : '';
                                const searchCategoryNames = selectedCategories.map((c) => c.categoryTitle).sort();
                                setFilters(prev => ({ ...prev, searchCategoryIds, searchSuperCategory, searchCategoryNames, showTable: false }));
                            }}
                            onRemove={(selectedCategories) => {
                                const searchCategoryIds = selectedCategories.map((v) => v.categoryId).sort().join(',');
                                const searchSuperCategory = selectedCategories.length > 0 ? selectedCategories[0].superCategory : '';
                                const searchCategoryNames = selectedCategories.map((c) => c.categoryTitle).sort();
                                setFilters(prev => ({ ...prev, searchCategoryIds, searchSuperCategory, searchCategoryNames, showTable: false }));
                            }}
                            ref={categoryFilterRef}
                        />
                    </div>
                    <div key="pir_filter_inp_subCategory" className="input--container" >
                        <CategoryAutocomplete
                            name="subCategoryIds"
                            id={'subCategoryIds'} nextId="brandIds" prevId="categoryIds"
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={250}
                            label={"Item Sub Category"}
                            searchPlaceholder={"Search By Sub Category"}
                            noDataLabel={"No Sub Category Found"}
                            categoryFor={1}
                            isParent="N"
                            selectedValues={filters.searchSubCategoryIds !== '' ? [filters.searchSubCategoryIds] : []}
                            onSelect={(selectedSubCategory, currentSelection) => {
                                const searchSubCategoryIds = selectedSubCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSubCategoryNames = selectedSubCategory.map((sc) => sc.categoryTitle).sort();
                                setFilters(previousFilters => ({ ...previousFilters, searchSubCategoryIds, searchSubCategoryNames, showTable: false }));
                            }}
                            onRemove={(selectedSubCategory, currentSelection) => {
                                const searchSubCategoryIds = selectedSubCategory.map((v) => v.categoryId).sort().join(',');
                                const searchSubCategoryNames = selectedSubCategory.map((sc) => sc.categoryTitle).sort();
                                setFilters(previousFilters => ({ ...previousFilters, searchSubCategoryIds, searchSubCategoryNames, showTable: false }));
                            }}
                            ref={subCategoryFilterRef}
                        />
                    </div>
                    <div key="pir_filter_inp_brand" className="input--container" >
                        <BrandAutocomplete
                            name="brandIds"
                            id={'brandIds'} nextId="ItemIds" prevId="subCategoryIds"
                            label={"Brand"}
                            searchPlaceholder={"Search By Brand Category"}
                            noDataLabel={"No Brand Found"}
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={350}
                            selectedValues={filters.searchBrandIds ? [filters.searchBrandIds] : ['']}
                            onSelect={(selectedBrands, currentSelection) => {
                                const searchBrandIds = selectedBrands.map((v) => v.brandId).sort().join(',');
                                const searchBrandNames = selectedBrands.map((b) => b.brandName).sort();
                                setFilters(previousFilters => ({ ...previousFilters, searchBrandIds, searchBrandNames, showTable: false }));
                            }}
                            onRemove={(selectedBrands, currentSelection) => {
                                const searchBrandIds = selectedBrands.map((v) => v.brandId).sort().join(',');
                                const searchBrandNames = selectedBrands.map((b) => b.brandName).sort();
                                setFilters(previousFilters => ({ ...previousFilters, searchBrandIds, searchBrandNames, showTable: false }));
                            }}
                            ref={brandFilterRef}
                        />
                    </div>
                    <div key="pir_filter_inp_item" className="input--container" >
                        <ItemAutocomplete
                            name="ItemIds"
                            label={"Item Name & Part No."}
                            searchPlaceholder={"Search By Item Name & Part No."}
                            noDataLabel={"No Item Found"}
                            isCompulsory={false}
                            singleSelect={false}
                            listWidth={450}
                            forAllItems={'Y'}
                            onlyLoginBranchMappedModelsItems={true}
                            selectedValues={filters.searchItemIds !== '' ? [filters.searchItemIds] : []}
                            onSelect={(selectedItems) => {
                                const searchItemIds = selectedItems.map((i) => i.itemId).sort().join(',');
                                const searchItemNames = selectedItems.map(i => i.itemName);
                                setFilters(previousFilters => ({ ...previousFilters, searchItemIds, searchItemNames, showTable: false }));
                            }}
                            onRemove={(selectedItems) => {
                                const searchItemIds = selectedItems.map((i) => i.itemId).sort().join(',');
                                const searchItemNames = selectedItems.map(i => i.itemName);
                                setFilters(previousFilters => ({ ...previousFilters, searchItemIds, searchItemNames, showTable: false }));
                            }}
                            ref={itemFilterRef}
                            id="ItemIds"
                            nextId='generatePIR'
                            prevId='brandIds'
                        />
                    </div>
                    <div className='btn--container'>
                        <div className="dashed--btn" id="generatePIR" tabIndex="0" style={{ marginLeft: '0', marginRight: '22px' }} onClick={() => { generatePurchaseInvoiceData(); }}
                            onKeyDown={(e) => { handlekeyDown(e, `purchaseInvoiceFromDate`, `resetBtn`, `generatePIR`) }}>Generate Report</div>
                        <div key="pir_filter_inp_frd" className="dashed--btn" onClick={() => purchaseInvoiceReportFilterReset(false)}
                            id="resetBtn"
                            tabIndex="0"
                            style={{ marginLeft: '4px' }}
                            onKeyDown={(e) => { handlekeyDown(e, `generatePIR`, `purchaseInvoiceFromDate`, `resetBtn`) }}>Reset
                        </div>
                    </div>
                </div>
                <div className="report--container">
                    {filters?.showTable &&
                        <PurchaseInvoiceReportList filters={filters} loadData={loadData} setLoadData={setLoadData} />
                    }
                </div>
            </div>
        </>
    )
}
export default PurchaseInvoiceReport;